import React from 'react'

export default function BonusProgram() {
  return (
    <iframe width="100%" height="100%" src="https://stockpoint.millanova.com/bonuses"></iframe>
  )
}
